import React from 'react'
import styled from 'styled-components'
import { Alert } from '@components'
import { DetailSection } from './InvoicingDetails.styled'

type AlertType = 'warning' | 'info'

interface Props {
  type: AlertType
  title: string
  description: React.ReactElement
}

export const PostDueAutomationAlertLayout: React.FC<Props> = ({ type, title, description }) => (
  <DetailSection>
    <Alert type={type} title={title} description={description} marginBottom={0} />
  </DetailSection>
)

export const PostDueAutomationAlertDescriptionStack = styled.div`
  display: flex;
  flex-direction: column;
`

export const PostDueAutomationAlertLineStack = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.xs}rem;
`

export const PostDueAutomationAlertAction = styled.div`
  margin-top: ${({ theme }) => theme.spacing.sm}rem;
`
